const USER_COLUMNS = [
  { header: "User name", key: "user_name" },
  { header: "User email", key: "user_email" },
  { header: "Super org", key: "super_org" },
  { header: "Specialty", key: "specialty" },
  { header: "Monthly recordings", key: "recordings" },
  { header: "Last recording date", key: "last_recording_date" },
];

const BREAKDOWN_COLUMNS = [
  { header: "Licensed", key: "licensed" },
  { header: "Licensed Δ", key: "mom_licensed_delta" },
  { header: "Monthly recordings", key: "recordings" },
  { header: "Cumulative recordings", key: "cumulative_recordings" },
  { header: "Avg recordings daily", key: "avg_recordings_daily" },
];

const PRICING_COLUMNS = [
  { header: "Cost / user", key: "cost_per_user", format: "currency" },
  { header: "Revenue", key: "revenue", format: "currency" },
];

const currentBreakdown = (rows) => (rows || []).filter((row) => row.licensed > 0);

export function financialReviewExportSheets({
  licensed_users,
  by_super_org,
  by_specialty,
  top_specialty_by_super_org,
  summary,
  report_month,
  previous_report_month,
} = {}) {
  return [
    {
      name: "Summary",
      columns: [
        { header: "Report month", key: "report_month" },
        { header: "Previous month", key: "previous_report_month" },
        { header: "Licensed", key: "licensed" },
        { header: "Monthly recordings", key: "recordings" },
        { header: "Cumulative recordings", key: "cumulative_recordings" },
        { header: "Avg recordings daily", key: "avg_recordings_daily" },
        { header: "Avg DAU", key: "avg_dau" },
        { header: "Licensed Δ", key: "mom_licensed_delta" },
        { header: "Revenue", key: "revenue", format: "currency" },
        { header: "Priced super orgs", key: "priced_org_count" },
      ],
      rows: [{ report_month, previous_report_month, ...(summary || {}) }],
    },
    { name: "Licensed users", columns: USER_COLUMNS, rows: licensed_users || [] },
    {
      name: "By super org",
      columns: [{ header: "Super org", key: "super_org" }, ...BREAKDOWN_COLUMNS, ...PRICING_COLUMNS],
      rows: currentBreakdown(by_super_org),
    },
    {
      name: "By specialty",
      columns: [{ header: "Specialty", key: "specialty" }, ...BREAKDOWN_COLUMNS],
      rows: currentBreakdown(by_specialty),
    },
    {
      name: "Top specialty by super org",
      columns: [
        { header: "Super org", key: "super_org" },
        { header: "Top specialty", key: "specialty" },
        { header: "Licensed", key: "licensed" },
        { header: "Monthly recordings", key: "recordings" },
      ],
      rows: top_specialty_by_super_org || [],
    },
  ];
}
